import { render } from "./refundDetail.vue?vue&type=template&id=969e8d36&scoped=true"
import script from "./refundDetail.vue?vue&type=script&lang=js"
export * from "./refundDetail.vue?vue&type=script&lang=js"

import "./refundDetail.vue?vue&type=style&index=0&id=969e8d36&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-969e8d36"]])

export default __exports__